import type { TripKey } from '../types/drive';
import { DRIVE_PROFILES } from '../config/profiles';
import { StateManager } from './StateManager';
import type { DriveProfileKey } from '../types/drive';

export class TripManager {
  constructor(private state: StateManager) {}

  triggerTrip(tripKey: TripKey): string | null {
    const profileKey = this.state.get('selectedProfileKey');
    const profile = DRIVE_PROFILES[profileKey];
    if (!profile) return null;
    const tripInfo = profile.tripCodes[tripKey];
    if (!tripInfo) return null;

    this.state.set('activeTrip', tripInfo.code);
    return tripInfo.desc;
  }

  resetTrip(): void {
    this.state.set('activeTrip', null);
  }

  getActiveTripCode(): string | null {
    return this.state.get('activeTrip');
  }

  getActiveTripDescription(profileKey: DriveProfileKey): string | null {
    const code = this.state.get('activeTrip');
    if (!code) return null;

    const profile = DRIVE_PROFILES[profileKey];
    if (!profile) return null;
    for (const key of Object.keys(profile.tripCodes) as TripKey[]) {
      if (profile.tripCodes[key].code === code) {
        return profile.tripCodes[key].desc;
      }
    }
    return null;
  }
}
